<template>
  <div class="newsletter__widget hide-for-small-only" v-if="showPopup === 'true'">
    <span class="_close" @click="closePopup()"></span>
    <div v-if="!success" class="newsletter__widget_sign-in">
      <div class="_intro">
        <h5>Schrijf je in en ontvang <span>5 euro korting</span> op je eerste bestelling</h5>
        <p>(bij bestelling vanaf &euro; 40,-)</p>
      </div>
      <div class="_form">
        <form action="https://allesvoorparket.us11.list-manage.com/subscribe/post?u=52bd990e0897d865ffb40bb8b&amp;id=4c4990f772" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
            <div id="mc_embed_signup_scroll">
                <div class="mc-field-group">
                    <input type="email" placeholder="Je e-mail adres" value="" name="EMAIL" class="required email newsletter__input" id="mce-EMAIL">
                    <button type="submit" name="subscribe" id="mc-embedded-subscribe" class="_button">Inschrijven</button>
                </div>
                <div id="mce-responses" class="clear">
                    <div class="response" id="mce-error-response" style="display:none"></div>
                    <div class="response" id="mce-success-response" style="display:none"></div>
                </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_52bd990e0897d865ffb40bb8b_4c4990f772" tabindex="-1" value=""></div>
                <div class="clear"></div>
            </div>
        </form>
      </div>
    </div>
    <div class="newsletter__widget_success" v-else>
      <h5>Bedankt voor je inschrijving!</h5>
      <p>Check je inbox voor de kortingscode en plaats direct je bestelling met 5 euro korting</p>
      <a href="#" class="_button" @click.prevent.stop="closePopup()">Shoppen maar!</a>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import {apiClient} from '../shared/services/api-client';
  import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
  import {email, required} from 'vee-validate/dist/rules';
  import {UICoreCookies} from "@flashpointbv/solar-ui-core";

  extend('required', required);
  extend('email', email);

  @Component({
    name: 'newsletter-widget',
    components: {
      ValidationProvider,
      ValidationObserver
    }
  })

  export default class extends Vue {
    private email: string = '';
    private message: string = '';
    private success: boolean = false;
    private isLoading: boolean = false;
    private showPopup: string | void = new UICoreCookies().getCookie('cookie-newsletter') || 'true';

    private closePopup(): void {
      new UICoreCookies().setCookie('cookie-newsletter', 'false', 86000);
      this.showPopup = 'false';
    }
  }
</script>
